import api from '@/store/api'
import errorUtil from '@windsor-telecom/client-core/src/utils/errors'

const actions = {
    me: async () => {
        try {
            const response = await api.auth.me()
            return response
        } catch (e) {
            return Promise.reject(errorUtil.mapError(e))
        }
    }
}

export default {
    namespaced: true,
    actions
}
